import {LitElement, html, css, TemplateResult} from "lit";
import {customElement, property} from "lit/decorators.js";
import {deleteSave} from "../services/routeService";

export interface Save {
    user_id?: string;
    save_id: string;
    name: string;
    current_room?: string;
    updatedAt?: Date;
}

@customElement("save-popup")
export class SavePopup extends LitElement {
    @property({type: Array}) public saves: Save[] = [];

    public static styles = css`
        /* Add your styles here */
        :host {
            display: none;
            position: fixed; /* Position the popup relative to the viewport */
            left: 50%; /* Center the popup horizontally */
            transform: translate(-50%, -30%); /* Adjust the popup's position so it's centered */
            color: #00c000;
            font-family: Arial, sans-serif;
            background-color: black;
            border: 1px solid #00FF00;
            border-radius: 5px;
            padding: 10px;
            width: 250px;
            text-align: center;
        }

        h2 {
            color: #00FF00;
            font-size: 1.7em;
            margin: 0 0 10px 0;
        }

        ul {
            list-style-type: none;
            padding: 0;
            margin: 0;
        }

        li {
            cursor: pointer;
            padding: 5px 10px;
            margin-bottom: 5px;
            border-radius: 3px;
            color: #00FF00;
        }

        li:hover {
            color: #00c000;
            background-color: #101010;
        }

        button {
            color: #00FF00;
            background-color: black;
            border: 1px solid #00FF00;
            border-radius: 3px;
            padding: 5px 10px;
            cursor: pointer;
        }

        button:hover {
            color: #00c000;
            background-color: #101010;
        }
    `;

    public render(): TemplateResult<1> {
        return html`
            <div>
                <h2>Select a save</h2>
                <button @click=${this.handleCloseClick}>Close</button>
                <ul>
                    ${this.saves.map(
            (save) => html`
                            <li>
                                ${save.name}
                                ${save.updatedAt ? new Date(save.updatedAt).toLocaleString() : ""}
                                ${save.current_room ? save.current_room : ""} <br>
                                <button @click=${(): void => this._handleSaveClick(save)}>Select</button>
                                ${save.updatedAt ? html`<button @click=${async (): Promise<void> => await this.handleRemoveClick(save)}>Remove</button>` : ""}
                            </li>`
        )}
                </ul>
            </div>
        `;
    }

    private _handleSaveClick(save: Save): void {
        this.dispatchEvent(new CustomEvent("save-selected", {detail: save}));
    }

    private async handleRemoveClick(save: Save): Promise<void> {
        await deleteSave(save.save_id);
        this.saves = this.saves.filter((s) => s.save_id !== save.save_id);
    }

    private handleCloseClick(): void {
        this.style.display = "none";
    }
}